import { useState } from "react"

import { useTranslation } from "react-i18next"

import Button from "../../../../Components/Button"
import Icon from "../../../../Icon"
import { FaqStub } from "../FaqStub"

// §BLOCK 1.2 — "Learn more about Digital Receipt" button (Header right side).
// Реєструється в TitleSectionContext з ReceiptPage/index.js.
//
// Export deliberately does not live here. It used to be rendered alongside on mobile, putting a
// second Export button on screen next to the filter bar's own -- two controls doing the same thing,
// against the single-action requirement (CHA1-1348). The header copy was also the weaker of the
// two: it checked only `isDemo`, so it stayed clickable in External Demo mode.
const LearnMoreAction = ({ isMobile }) => {
  const { t } = useTranslation()
  const [open, setOpen] = useState(false)

  return (
    <>
      {open && <FaqStub isMobile={isMobile} open={open} onClose={() => setOpen(false)} />}

      <Button
        type="default"
        icon={<Icon type="question_help" style={isMobile ? {} : { fontSize: 16 }} />}
        onClick={() => setOpen(true)}
      >
        {!isMobile && t("Learn more about Digital Receipt")}
      </Button>
    </>
  )
}

export default LearnMoreAction
